import { render, staticRenderFns } from "./SurveyAttentionList.vue?vue&type=template&id=97bc1b12&"
import script from "./SurveyAttentionList.vue?vue&type=script&lang=ts&"
export * from "./SurveyAttentionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports